var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeustLoginLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 57,
    viewBox: "0 0 66 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5774_16955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.963586 37.4948L5.35722 0.5H22.4149L15.8244 56.5C6.7787 56.5 -0.199436 47.5052 0.963586 37.4948Z",
    fill: "#F60F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4768 56.4995L25.9042 10.2197H42.9619L37.5345 56.4995H20.4768Z",
    fill: "#F60F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1868 56.5L48.7772 0.5H65.8349L59.2444 56.5H42.1868Z",
    fill: "#F60F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5774_16955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 56,
    fill: "white",
    transform: "translate(0.835449 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeustLoginLogo);
export default __webpack_public_path__ + "static/media/geustLoginLogo.59a719511b023d84f0252601482f92ba.svg";
export { ForwardRef as ReactComponent };